import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BaseHTTPHandlerService } from '../httpClientAbstract/httpClient.service.abstract';
import { select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';

@Injectable({ providedIn: 'root' })
export class FctHttpService extends BaseHTTPHandlerService {
	private matterId_ = select(SelectedMatter.id);

	get basePath() {
		return `title-insurance/fct/${this.matterId_()}`;
	}

	syncStatus() {
		return firstValueFrom(this.put('sync-status'));
	}
}
